module.exports = __webpack_public_path__ + "static/media/emoji-high-score-2x.0443de18.png";